import React from "react";
import { Box, Button, Flex, Heading, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setListingQueryParams } from "../../redux/reducers/propertyReducer";
import { FormattedMessage } from "react-intl";

const CallToAction = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleBrowsePropertiesClick = () => {
    dispatch(
      setListingQueryParams({
        skip: 0,
        take: 6,
        currentPage: 1,
        property_type: "AP",
      })
    );
    navigate("/properties");
  };

  const handleSubmitPropertyClick = () => {
    navigate("/properties");
  };

  // Reusing the specific SVG arrow from the original code but optimized
  const CustomArrow = () => (
    <Box as="span" ml={1}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        fill="currentColor"
        viewBox="0 0 16 16"
      >
        <path
          fillRule="evenodd"
          d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0z"
        />
      </svg>
    </Box>
  );

  return (
    <Box
      position="relative"
      backgroundImage="url(/icons/buy-or-sell.jpg)"
      backgroundSize="cover"
      backgroundPosition="center"
      minHeight={{ base: "500px", md: "700px" }}
      display="flex"
      alignItems="center"
      justifyContent="center"
      w="100%"
      mx="auto"
      overflow="hidden"
      _before={{
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bg: "rgba(18, 25, 38, 0.9)",
        zIndex: 1,
      }}
    >
      <Flex
        direction="column"
        align="center"
        textAlign="center"
        position="relative"
        zIndex={2}
        p={{ base: 6, md: 8 }}
        maxW="1100px"
        width="100%"
      >
        <Text
          color="white"
          fontSize={{ base: "sm", md: "md" }}
          fontWeight="600"
          mb={6}
          letterSpacing="4px"
          textTransform="uppercase"
          opacity={0.9}
        >
          <FormattedMessage id="buy_or_sell" />
        </Text>

        <Heading
          as="h2"
          color="white"
          fontSize={{ base: "2xl", md: "4xl" }}
          fontWeight="700"
          mb={2}
          lineHeight="1.2"
          maxW="900px"
        >
          <FormattedMessage id="buy_or_sell_description" />
        </Heading>

        <Heading
          as="h3"
          color="white"
          fontSize={{ base: "2xl", md: "4xl" }}
          fontWeight="700"
          mb={12}
          lineHeight="1.2"
        >
          <FormattedMessage id="awesome_solution" />
        </Heading>

        <Flex
          gap={{ base: 4, md: 6 }}
          direction={{ base: "column", sm: "row" }}
          w={{ base: "100%", sm: "auto" }}
          justify="center"
          align="center"
        >
          <Button
            bg="#E2B150"
            color="black"
            h={{ base: "54px", md: "60px" }}
            px={{ base: 8, md: 10 }}
            borderRadius="10px"
            fontSize={{ base: "sm", md: "md" }}
            fontWeight="700"
            _hover={{ bg: "#c99a3d", transform: "translateY(-2px)" }}
            _active={{ transform: "translateY(0)" }}
            transition="all 0.2s"
            onClick={handleSubmitPropertyClick}
            rightIcon={<CustomArrow />}
            w={{ base: "100%", sm: "auto" }}
          >
            <FormattedMessage id="submit_property" defaultMessage="Submit Property" />
          </Button>

          <Button
            bg="white"
            color="black"
            h={{ base: "54px", md: "60px" }}
            px={{ base: 8, md: 10 }}
            borderRadius="10px"
            fontSize={{ base: "sm", md: "md" }}
            fontWeight="700"
            _hover={{ bg: "#f0f0f0", transform: "translateY(-2px)" }}
            _active={{ transform: "translateY(0)" }}
            transition="all 0.2s"
            onClick={handleBrowsePropertiesClick}
            rightIcon={<CustomArrow />}
            w={{ base: "100%", sm: "auto" }}
          >
            <FormattedMessage id="browse_properties" />
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};

export default CallToAction;

